export default "__VITE_ASSET__B0a9CDQb__"